export default __webpack_public_path__ + "images/LEVELSPAIN.27b6cba.png";